import { AppState } from '@/vuex/store';
import customerRemarkRule, { CustomerRemarkRuleType, CustomerRemarkRule } from '../../models/CustomerRemarkRule';

export default {
  UPDATE_CUSTOMER_REMARK_RULE: (state: AppState, params: any) => {
    state.customerState.customerRemarkRule[params.key] = params.value;
    if (params.key === 'type') {
      if (params.value === CustomerRemarkRuleType.Link) {
        state.customerState.customerRemarkRule.keyword = undefined;
        state.customerState.customerRemarkRule.link = {};
      } else if (params.value === CustomerRemarkRuleType.Keyword) {
        state.customerState.customerRemarkRule.link = undefined;
        state.customerState.customerRemarkRule.keyword = {
          fullMatch: true,
        };
      } else {
        state.customerState.customerRemarkRule.link = undefined;
        state.customerState.customerRemarkRule.keyword = undefined;
      }
    }
    if (params.key === 'permanent') {
      state.customerState.customerRemarkRule.period = params.value ? undefined : {
        startNow: true,
      };
    }
  },
  SET_CUSTOMER_REMARK_RULE: (state: AppState, rule: CustomerRemarkRule) => {
    state.customerState.customerRemarkRule = rule;
  },
  UPDATE_CUSTOMER_REMARK_RULE_LINK: (state: AppState, params: any) => {
    if (state.customerState.customerRemarkRule.link === undefined) {
      state.customerState.customerRemarkRule.link = {};
    }
    state.customerState.customerRemarkRule.link[params.key] = params.value;
  },
  UPDATE_CUSTOMER_REMARK_RULE_KEYWORD: (state: AppState, params: any) => {
    if (state.customerState.customerRemarkRule.keyword === undefined) {
      state.customerState.customerRemarkRule.keyword = {};
    }
    state.customerState.customerRemarkRule.keyword[params.key] = params.value;
  },
  UPDATE_CUSTOMER_REMARK_RULE_PERIOD: (state: AppState, params: any) => {
    state.customerState.customerRemarkRule.period[params.key] = params.value;
  },
  UPDATE_CUSTOMER_REMARK_RULES: (state: AppState, rules: CustomerRemarkRule[]) => {
    state.customerState.customerRemarkRules = rules;
  },
  RESET_CUSTOMER_REMARK_RULE: (state: AppState) => {
    state.customerState.customerRemarkRule = JSON.parse(JSON.stringify(customerRemarkRule));
  },
};
